import { render } from "./ReportRevenueBranch.vue?vue&type=template&id=a6803a96&scoped=true"
import script from "./ReportRevenueBranch.vue?vue&type=script&lang=js"
export * from "./ReportRevenueBranch.vue?vue&type=script&lang=js"

import "./ReportRevenueBranch.vue?vue&type=style&index=0&id=a6803a96&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6803a96"]])

export default __exports__